import ContentContainer from "@/components/layout/ContentContainer";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";

export const SLAReportDetailsEmpty = () => (
  <ContentContainer title="Loading SLA Report..">
    <LoadingContainer />
  </ContentContainer>
);
